var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 133,
    viewBox: "0 0 123 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 66.5C133 103.227 103.227 133 66.5 133C29.7731 133 0 103.227 0 66.5C0 29.7731 29.7731 0 66.5 0C103.227 0 133 29.7731 133 66.5ZM23.2244 66.5C23.2244 90.4004 42.5996 109.776 66.5 109.776C90.4004 109.776 109.776 90.4004 109.776 66.5C109.776 42.5996 90.4004 23.2244 66.5 23.2244C42.5996 23.2244 23.2244 42.5996 23.2244 66.5Z",
    fill: "#F5FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllips);
export default __webpack_public_path__ + "static/media/ellips.81a41818e3f0180c368378fc58b2b646.svg";
export { ForwardRef as ReactComponent };